<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          size="small"
          unlink-panels
          :picker-options="pickerOptions"
          @change="changeTimeValue"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <input-search placeholder="来访人姓名/来访人手机号" @search="searchKey" />
    </div>
    <table-main :selection="false" :hasOperation="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @lookOver="lookOver"/>

    <el-dialog
      :visible.sync="dialogVisible"
      width="40%">
      <img :src="lookOverImg" alt="" style="width: 90%;margin: 0 auto;">
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import InputSearch from "../../../components/Input/InputSearch";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Visitor";
import { errorHandler } from "../../../utils/errorHandler";

export default {
  components: {
    TableMain,
    InputSearch,
    Breadcrumb
  },
  name: "credit-card-record",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧访客",
          name: "appointment-record"
        },
        {
          value: "出入记录"
        }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      tableHead: [
        {
          prop: "visitorName",
          label: "来访人姓名"
        },
        {
          prop: "visitorPhone",
          label: "来访人手机号"
        },
        {
          prop: "deviceName",
          label: "设备名称"
        },
        {
          prop: "recognitionTypeText",
          label: "识别类型"
        },
        {
          prop: "scenesText",
          label: "场景"
        },
        {
          prop: "brushCodeTime",
          label: "出入时间"
        },
        {
          prop: "visitorPicSnapUrl",
          label: "人脸照片",
          isLookOver: true
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      timeValue: [],
      lookOverImg: "",
      dialogVisible: false,
      requestData: {
        pageNum: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        searchKey: ""
      }
    };
  },
  created() {
    // this.getPage()
    this.getCreatTime();
  },
  activated() {
    this.getPage();
  },
  methods: {
    getCreatTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
      // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
      // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
      this.timeValue[0] = year + "-" + month + "-" + date;
      this.timeValue[1] = year + "-" + month + "-" + date;
      this.getPage();
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      reqData.startTime = "";
      reqData.endTime = "";
      if (this.timeValue) {
        if (this.timeValue.length > 0) {
          reqData.startTime = `${this.timeValue[0]} 00:00:00`;
          reqData.endTime = `${this.timeValue[1]} 23:59:59`;
        }
      }
      this.$axios
        .post(api.getRecordPage, reqData)
        .then(res => {
          let list = res.data.data.list;
          this.total = res.data.data.total;
          list.map(v => {
            if (v.scenes === "1") {
              v.scenesText = "门通道";
            } else if (v.scenes === "2") {
              v.scenesText = "电梯";
            }
            if (v.recognitionType === "1") {
              v.recognitionTypeText = "二维码";
            } else if (v.recognitionType === "2") {
              v.recognitionTypeText = "人脸识别";
            }
            v.picUrl = v.visitorPicSnapUrl;
          });
          this.tableData = list;
        })
        .catch(errorHandler("获取预约记录失败"));
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changeTimeValue() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },

    lookOver(imgUrl) {
      this.lookOverImg = imgUrl;
      this.dialogVisible = true;
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>
<style lang="less">
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/VisitorCenter/CreditCardRecord/CreditCardRecord.vue